import { render, staticRenderFns } from "./SearchSection.vue?vue&type=template&id=66f1e6b4&scoped=true"
import script from "./SearchSection.vue?vue&type=script&lang=js"
export * from "./SearchSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f1e6b4",
  null
  
)

export default component.exports